import { useEnvStore } from 'store'
import { VendorCardType } from '../../../../debit-card/src/constants/debit'
import { RequestService } from '../../RequestService'
import { ApiRoute } from './api-route'

class DebitCardRequest extends RequestService {
  options = {
    ignoreToCamelCase: true,
    isShowError: true,
  }
  constructor() {
    super()
  }

  setBaseUrl() {
    const envStore = useEnvStore()

    return envStore.config?.app
  }
  getMyCards(isSubCard: boolean, isHidden: boolean) {
    const api = !isSubCard ? ApiRoute.MyCards : ApiRoute.MySubCards
    const params = {
      is_hidden: isHidden ? 1 : 0,
    }
    return this.post<MyCardsItem[]>(api, { ...params }, this.options)
  }
  getMyCardStats(isSubCard: boolean, isHidden: boolean) {
    const api = !isSubCard ? ApiRoute.MyCardStats : ApiRoute.MySubCardStats
    const params = {
      is_hidden: isHidden ? 1 : 0,
    }
    return this.post<MyCardStats>(api, { ...params }, this.options)
  }
  getVendorCards(type: VendorCardType) {
    const api = type === VendorCardType.Card ? ApiRoute.VendorCards : ApiRoute.SubVendorCards
    return this.post<VendorCard[]>(api, {}, this.options)
  }

  getExpressInfo(data = {}) {
    return this.post<MyCardExpressInfo>(ApiRoute.ExpressInfo, data, this.options)
  }
  getUserBillInfo(data = {}) {
    return this.post<UserBill>(ApiRoute.UserBillInfo, data, this.options)
  }
  getUserBill(data = {}) {
    return this.post<UserBillResponse>(ApiRoute.UserBill, data, this.options)
  }
  getVendorCardRight(data = {}) {
    return this.post<VendorCardRight[]>(ApiRoute.VendorCardRight, data, this.options)
  }
  getMyCardInfo(data = {}) {
    return this.post<MyCardInfo>(ApiRoute.MyCardInfo, data, this.options)
  }

  getMyCardInfoEncrypt(data = {}) {
    return this.post<MyCardInfo>(ApiRoute.MyCardInfoEncrypt, data, this.options)
  }

  updateCardUserName(data = {}) {
    return this.post<MyCardInfo>(ApiRoute.UpdateCardUserName, data, this.options)
  }
  updateCardName(data = {}) {
    return this.post<MyCardInfo>(ApiRoute.UpdateCardName, data, this.options)
  }
  updateSubCardName(data = {}) {
    return this.post<MyCardInfo>(ApiRoute.UpdateSubCardName, data, this.options)
  }
  unlockCard(data = {}) {
    return this.post<MyCardInfo>(ApiRoute.UnlockCard, data, this.options)
  }
  lockCard(data = {}) {
    return this.post<MyCardInfo>(ApiRoute.LockCard, data, this.options)
  }
  resetPinUnLock(data = {}) {
    return this.post<MyCardInfo>(ApiRoute.PinLock, data, this.options)
  }
  updateMaxSpendAmountDay(data = {}) {
    return this.post<MyCardInfo>(ApiRoute.UpdateMaxSpendAmountDay, data, this.options)
  }
  updateMaxSpendAmountSingle(data = {}) {
    return this.post<MyCardInfo>(ApiRoute.UpdateMaxSpendAmountSingle, data, this.options)
  }
  updateMaxSpendAmountMonth(data = {}) {
    return this.post<MyCardInfo>(ApiRoute.UpdateMaxSpendAmountMonth, data, this.options)
  }
  setParentSetting(data: { user_card_id: string; sub_card_limit: string; spend_limit_type: number }) {
    return this.post<MyCardInfo>(ApiRoute.SetParentSetting, data, this.options)
  }
  updateMaxATMAmountSingle(data = {}) {
    return this.post<MyCardInfo>(ApiRoute.UpdateMaxATMAmountSingle, data, this.options)
  }
  updateMaxATMAmountDay(data = {}) {
    return this.post<MyCardInfo>(ApiRoute.UpdateMaxATMAmountDay, data, this.options)
  }
  updateMaxATMAmountMonth(data = {}) {
    return this.post<MyCardInfo>(ApiRoute.UpdateMaxATMAmountMonth, data, this.options)
  }
  updatePin(data = {}) {
    return this.post<MyCardInfo>(ApiRoute.UpdatePin, data, this.options)
  }
  /** 获取更新PIN码的URL */
  getUpdatePinUrl(data: { user_card_id: string }) {
    return this.post<string>(ApiRoute.GetUpdatePinUrl, data, this.options)
  }
  stickyTop(data = {}) {
    return this.post<MyCardInfo>(ApiRoute.StickyTop, data, this.options)
  }
  /** 删除卡片（隐藏卡片） */
  hiddenCard(data: { user_card_id: string; is_lock: 0 | 1 }) {
    return this.post<MyCardInfo>(ApiRoute.HiddenCard, data, this.options)
  }
  /** 删除卡片（隐藏卡片） */
  showCard(data: { user_card_id: string; is_un_lock: 0 | 1 }) {
    return this.post<MyCardInfo>(ApiRoute.ShowCard, data, this.options)
  }
  /** 销卡 */
  cancelCard(data: { user_card_id: string }) {
    return this.post<void>(ApiRoute.CancelCard, data, this.options)
  }
  getCoinList(data = {}) {
    return this.post<Record<number, ApiResponse.CoinItem>>(ApiRoute.CoinList, data, this.options)
  }

  submitCardInfo(data: any) {
    // TODOS: 测试时不提交验证码，则后端不会验证验证码
    // delete data.mobile_code
    return this.post<{ user_card_id: string }>(ApiRoute.SubmitCardInfo, data, this.options)
  }
  myApplyingCard(data = {}) {
    return this.post<MyApplyingCardInfo>(ApiRoute.MyApplyingCard, data, this.options)
  }
  openCardFees(data = {}) {
    return this.post<OpenCardFeesInfo>(ApiRoute.OpenCardFees, data, this.options)
  }
  paymentOpenCardFee(data = {}, type: VendorCardType) {
    const api = type === VendorCardType.Card ? ApiRoute.PaymentOpenCardFee : ApiRoute.PaymentOpenSubCardFee
    return this.post<OpenCardFeesInfo>(api, data, this.options)
  }
  // 获取VIP阶梯消费手续费
  listVipTieredFee(data: { cvc_id: string }) {
    return this.post<VipTieredFeeItem[]>(ApiRoute.ListVipTieredFee, data, this.options)
  }
  // 获取消费报告
  getConsumptionReport(data: { user_card_id: string; record_type?: number }) {
    return this.post<ConsumptionReportResponse>(ApiRoute.ConsumptionReport, data, this.options)
  }

  // 账单导出 - 获取导出限制
  getExportBillLimit() {
    return this.post<ExportBillLimitResponse>(ApiRoute.ExportBillLimit, {}, this.options)
  }

  // 账单导出 - 生成账单
  generateBill(data: { file_type: string; bill_type: string; lang_type: string; user_card_id: number; start_time: number }) {
    return this.post<GenerateBillResponse>(ApiRoute.GenerateBill, data, this.options)
  }

  // 账单导出 - 获取导出历史列表
  getExportHistoryList(data: { bill_type: string; page?: number; page_size?: number }) {
    return this.post<ExportHistoryResponse>(ApiRoute.ExportHistoryList, data, this.options)
  }

  // 账单导出 - 发送账单邮件
  exportBillSendEmail(data: { email: string; eb_no: string }) {
    return this.post<ExportBillSendEmailResponse>(ApiRoute.ExportBillSendEmail, data, this.options)
  }

  // 账单导出 - 下载账单
  exportBillDownload(data: { eb_no: string }) {
    return this.post<ExportBillDownloadResponse>(ApiRoute.ExportBillDownload, data, this.options)
  }
  /** 发送短信验证码 */
  sendMobileCode(data: { mobile?: string; area?: string }) {
    return this.post<ApiResponse.StaticTableVersionInfo>(ApiRoute.SendMobileCode, data)
  }
  /** 发送邮箱验证码 */
  sendEmailCode(data: { email?: string }) {
    return this.post<ApiResponse.StaticTableVersionInfo>(ApiRoute.SendEmailCode, data)
  }

  // 获取帮助中心文章列表（用卡指南）
  getHelpCenterArticles(data: { type: number; page_count: number; page_size: number }) {
    return this.post<HelpCenterArticlesResponse>(ApiRoute.HelpCenterArticles, data, this.options)
  }
  /** 获取国家、省/州、城市三级联动下拉数据 */
  getCascadeAddress(data: { mobile?: string; area?: string }) {
    return this.post<CascadeAddress>(ApiRoute.CascadeAddress, data, this.options)
  }
  /** 获取KYC配置 */
  getKYCConfig(data: { cvc_id?: string }) {
    return this.post<KycConfig[]>(ApiRoute.GetKYCConfig, data, this.options)
  }
  /** 提交KYC数据 */
  submitKYCData(data: any, isSubCard = false) {
    const api = isSubCard ? ApiRoute.SubmitSubKYCData : ApiRoute.SubmitKYCData
    return this.post<ApiResponse.StaticTableVersionInfo>(api, data, this.options)
  }
  /** 提交KYC数据 */
  submitAddressInfo(data: any, isSubCard = false) {
    const api = isSubCard ? ApiRoute.SubmitSubAddressInfo : ApiRoute.SubmitAddressInfo
    return this.post<ApiResponse.StaticTableVersionInfo>(api, data, this.options)
  }

  /** 金融卡 - 开卡顺序 说明， 展示窗口顺序 1 kyc 2 快递信息 3 付款信息 */
  submitOrderDescription(data: { user_card_id: string }) {
    return this.post<SubmitOrderDescription>(ApiRoute.SubmitOrderDescription, data, this.options)
  }
  /**  附属卡 - 初始化 */
  initSubCard(data: any, isSwitch = false) {
    const api = isSwitch ? ApiRoute.SwitchToSubCard : ApiRoute.InitSubCard
    if (isSwitch) {
      delete data.cvc_id
    } else {
      delete data.card_no
    }
    return this.post<{ user_card_id: string }>(api, data, this.options)
  }
  /** 绑定卡号 */
  bindCard(data: any, isSubCard = false) {
    // TODOS: 测试时不提交验证码，则后端不会验证验证码
    // delete data.mobile_code
    const api = isSubCard ? ApiRoute.CreditCardBindByCode : ApiRoute.CreditCardBindByNo
    if (isSubCard) {
      delete data.card_no
    } else {
      delete data.safe_code
    }
    return this.post<BindCardResponse | VendorCard>(api, data, this.options)
  }
  /** 获取附属卡绑定码 */
  getSafeCode(data: { user_card_id: string }) {
    return this.post<{ safe_code: string; expiration_time: number }>(ApiRoute.GetSafeCode, data, this.options)
  }
  /** 获取默认信息 */
  getDefaultInfo() {
    return this.post<DefaultApplyInfo>(ApiRoute.GetDefaultInfo, {}, this.options)
  }
  /** 删除审批中的卡片 */
  deleteCard(data = {}) {
    return this.post<DefaultApplyInfo>(ApiRoute.DeleteCard, data, this.options)
  }
  /** 修改账单备注 */
  updateBillRemark(data: any) {
    return this.post<DefaultApplyInfo>(ApiRoute.UpdateBillRemark, data, this.options)
  }
  /** 储蓄卡 - 获取充值手续费及限额 */
  getRechargeFee(data: { cvc_id: string; recharge_amount: string }) {
    return this.post<RechargeFeeInfo>(ApiRoute.RechargeFee, data, this.options)
  }
  /** 储蓄卡 - 充值卡片 */
  rechargeCard(data: { user_card_id: number; recharge_amount: string; client_rate: string; client_remark: string; tradePwd: string; withoutTradePwd: string }) {
    return this.post<void>(ApiRoute.RechargeCard, data, {
      ...this.options,
      ignoreToCamelCaseFields: ['tradePwd', 'withoutTradePwd'],
    })
  }
  /** 修改卡片绑定的手机号 */
  changeMobile(data: { user_card_id: string | number; area: string; mobile: string; mobile_code?: string }) {
    return this.post<void>(ApiRoute.ChangeMobile, data)
  }
}

/** 应用服务接口 */
export const DebitCardServices = new DebitCardRequest()
